import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifySession } from '@onefootprint/fetch-hosted';
import type { IdentifyScope } from '@onefootprint/request-types';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import ErrorComponent from '@/idv/pages/onboarding/components/error';
import type { BootstrapData } from '@/idv/types';
import { type Context, IdentifyVariant } from '../../identify.types';
import Loading from '../loading';
const variantToTokenScope: Record<IdentifyVariant, IdentifyScope> = {
  [IdentifyVariant.updateLoginMethods]: 'auth',
  [IdentifyVariant.verify]: 'onboarding'
};
type InitProps = {
  bootstrapData: BootstrapData | undefined;
  defaultValues: {
    email: {
      value: string | undefined;
      isBootstrap: boolean | undefined;
    };
    phoneNumber: {
      value: string | undefined;
      isBootstrap: boolean | undefined;
    };
  };
  context: Context;
  onDone: (identifyToken: string) => Promise<void>;
  onError: (location: string, error: unknown) => void;
};
const Init = t0 => {
  const $ = _c(27);
  const {
    bootstrapData,
    defaultValues,
    context,
    onDone,
    onError
  } = t0;
  const {
    initArgs
  } = context;
  let hasAuthToken;
  let vaultData;
  if ($[0] !== bootstrapData || $[1] !== defaultValues || $[2] !== initArgs.initialAuthToken) {
    vaultData = {};
    hasAuthToken = !!initArgs.initialAuthToken;
    if (!hasAuthToken) {
      vaultData = {
        "id.email": defaultValues.email.value,
        "id.phone_number": defaultValues.phoneNumber.value
      };
      if (bootstrapData) {
        vaultData = Object.fromEntries(Object.entries(bootstrapData).map(_temp));
      }
    }
    $[0] = bootstrapData;
    $[1] = defaultValues;
    $[2] = initArgs.initialAuthToken;
    $[3] = hasAuthToken;
    $[4] = vaultData;
  } else {
    hasAuthToken = $[3];
    vaultData = $[4];
  }
  let t1;
  if ($[5] !== defaultValues || $[6] !== hasAuthToken || $[7] !== initArgs.initialAuthToken || $[8] !== initArgs.isComponentsSdk || $[9] !== initArgs.isLive || $[10] !== initArgs.obConfigAuth || $[11] !== initArgs.sandboxId || $[12] !== initArgs.variant || $[13] !== onDone || $[14] !== vaultData) {
    t1 = async () => {
      const {
        data
      } = await postHostedIdentifySession({
        body: {
          data: vaultData,
          scope: variantToTokenScope[initArgs.variant]
        },
        headers: {
          ...initArgs.obConfigAuth,
          "X-Fp-Authorization": initArgs.initialAuthToken,
          "X-Fp-Is-Bootstrap": defaultValues.email.isBootstrap || defaultValues.phoneNumber.isBootstrap,
          "X-Fp-Is-Components-Sdk": initArgs.isComponentsSdk,
          "X-Sandbox-Id": initArgs.isLive || hasAuthToken ? undefined : initArgs.sandboxId
        }
      });
      await onDone(data.token);
    };
    $[5] = defaultValues;
    $[6] = hasAuthToken;
    $[7] = initArgs.initialAuthToken;
    $[8] = initArgs.isComponentsSdk;
    $[9] = initArgs.isLive;
    $[10] = initArgs.obConfigAuth;
    $[11] = initArgs.sandboxId;
    $[12] = initArgs.variant;
    $[13] = onDone;
    $[14] = vaultData;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== onError) {
    t2 = error => {
      onError("init", error);
    };
    $[16] = onError;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== t1 || $[19] !== t2) {
    t3 = {
      mutationFn: t1,
      onError: t2
    };
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const sessionInitMutation = useMutation(t3);
  let t4;
  if ($[21] !== sessionInitMutation) {
    t4 = () => {
      sessionInitMutation.mutate();
    };
    $[21] = sessionInitMutation;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  useEffect(t4, t5);
  if (sessionInitMutation.isError) {
    let t6;
    if ($[24] !== sessionInitMutation.error) {
      t6 = <ErrorComponent error={sessionInitMutation.error} />;
      $[24] = sessionInitMutation.error;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    return t6;
  }
  let t6;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Loading />;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};
export default Init;
function _temp(t0) {
  const [k, t1] = t0;
  const {
    value
  } = t1;
  return [k, value];
}